import React, { useCallback, useEffect, useState } from "react";
import { AnimatePresence } from "framer-motion";
import {
  Container,
  MenuButton,
  Image,
  MenuOverlay,
  CloseButton,
  NavLinks,
  NavItem,
  LangSwitcher,
  Lang,
  ButtonsContainer,
} from "./styles";
import Logo from "../../../../../images/rde_standart.png";
import { useMobileHeader } from "./hooks/useMobileHeader.hook";
import { HeaderButtons } from "../components/headerButtons";
import { t } from "i18next";
import { HeaderText } from "../styles";
import { Close as CloseIcon, MenuOutlined } from "ui";
import { SubmitFormModal } from "../../submitFormModal";
import { useNavigate } from "react-router-dom";
import { ROUTE_URLS } from "../../../../../constants/consts";

interface MobileHeaderProps {
  showButtons: boolean;
}

export const MobileHeader = ({ showButtons }: MobileHeaderProps) => {
  const navigate = useNavigate();
  const {
    handleModalVisibility,
    languages,
    currentLanguage,
    handleChangeLanguage,
    isOpen,
  } = useMobileHeader();
  const body = document.body;
  const [isSubmitModalOpen, setIsSubmitModalOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      body.style.overflow = "hidden";
    } else {
      body.style.overflow = "initial";
    }

    return () => {
      body.style.overflow = "initial";
    };
  }, [body, isOpen]);

  const toggleSubmitModal = useCallback(() => {
    setIsSubmitModalOpen((prev) => !prev);
  }, []);

  const handleNavigateToSignIn = useCallback(() => {
    navigate(ROUTE_URLS.SIGN_IN);
    if (isOpen) {
      handleModalVisibility();
    }
  }, [handleModalVisibility, isOpen, navigate]);

  const handleNavigateToSignUp = useCallback(() => {
    navigate(ROUTE_URLS.SIGN_UP);
    if (isOpen) {
      handleModalVisibility();
    }
  }, [handleModalVisibility, isOpen, navigate]);

  const handleOpenSupplierModal = useCallback(() => {
    if (isOpen) {
      handleModalVisibility();
    }
    setIsSubmitModalOpen(true);
  }, [handleModalVisibility, isOpen]);

  return (
    <Container $showButtons={showButtons}>
      {showButtons ? (
        <HeaderButtons showButtons={showButtons} />
      ) : (
        <>
          <Image alt="logo" src={Logo} />
          <ButtonsContainer>
            <HeaderText onClick={handleNavigateToSignIn}>{t("authenticate")}</HeaderText>
            <MenuButton type="button" onClick={handleModalVisibility}>
              {isOpen ? <CloseIcon /> : <MenuOutlined />}
            </MenuButton>
          </ButtonsContainer>
        </>
      )}
      <AnimatePresence>
        {isOpen && (
          <MenuOverlay
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ duration: 0.3 }}
          >
            <CloseButton type="button" onClick={handleModalVisibility}>
              <CloseIcon />
            </CloseButton>
            <NavLinks>
              <NavItem type="button" onClick={handleOpenSupplierModal}>{t("section_secondary_button")}</NavItem>
              <NavItem type="button" onClick={handleNavigateToSignUp}>{t("section_primary_button")}</NavItem>
              <NavItem type="button" onClick={handleNavigateToSignIn}>{t("authenticate")}</NavItem>
            </NavLinks>
            <LangSwitcher>
              {languages.map((language) => (
                <Lang
                  key={language.value}
                  type="button"
                  $isActive={currentLanguage.value === language.value}
                  onClick={handleChangeLanguage(language.value)}
                >
                  {language.label}
                </Lang>
              ))}
            </LangSwitcher>
          </MenuOverlay>
        )}
      </AnimatePresence>
      <SubmitFormModal
        isSubmitModalOpen={isSubmitModalOpen}
        toggleModal={toggleSubmitModal}
      />
    </Container>
  );
};
